/*eslint-disable */

import {
  bus
} from '@/main';
import {mapGetters} from 'vuex';

export default {
  name: 'briefcase-storage-info',
  components: {},
  props: [],
  data () {
    return {
      getStorageInfoState:{},
      selfUserInfo:null
    }
  },
  computed: {
    ...mapGetters([
      'selfUserInfoGetters'
    ]),
    getSelfUserInfoFun(){
      this.selfUserInfo = this.$store.getters.selfUserInfoGetters.data
      return
    },
    getStorageInfoFun(){
      return this.$store.getters.getbriefcaseStorageInfoGetters
    }
  },
  mounted () {
  },
  created(){
   this.$store.dispatch('getbriefcaseStorageInfoAction')
  },
  methods: {
    briefcaseStorageBreakdownFun(){
      bus.$emit('normalBriefcaseViewStateBus', false)
      bus.$emit('briefcaseStorageBreakdownStateBus', true)
    },
    briefcaseActivityLogFun(){
      bus.$emit('normalBriefcaseViewStateBus', false)
      bus.$emit('briefcaseActivityLogStateBus', true)
    },
    trimDecimalVal(num){
      if(num != undefined){
        if(num === 0){
          return 0;
        }else{
          return num.toFixed(2).replace(/(\.0+|0+)$/, '');
        }
      }
    }
  },
  watch:{
    getStorageInfoFun(newVal, oldVal){
      this.getStorageInfoState = newVal.data
    },
    getSelfUserInfoFun(){
      return this.$store.getters.selfUserInfoGetters
    },
  }
}


